module.exports = __webpack_public_path__ + "static/hallie-0ef8f57371885faf6d35620e563e41ea.jpg";